import { render } from "./ListeDemandesArchives.vue?vue&type=template&id=ba56a4c4"
import script from "./ListeDemandesArchives.vue?vue&type=script&lang=js"
export * from "./ListeDemandesArchives.vue?vue&type=script&lang=js"

import "./ListeDemandesArchives.vue?vue&type=style&index=0&id=ba56a4c4&lang=scss"

import exportComponent from "/Users/anthony/Documents/APP/SIMEF LAST/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__